import { c, IllustrationFrame, sc, type IllustrationProps } from './Illustration';

/** Invite card. An envelope with a heart seal and a peeking card. */
export function Envelope(props: IllustrationProps) {
  return (
    <IllustrationFrame {...props}>
      <ellipse cx="80" cy="140" rx="52" ry="6" style={{ fill: sc('border.default') }} />
      <rect
        x="44"
        y="30"
        width="72"
        height="64"
        rx="8"
        style={{ fill: sc('bg.surface'), stroke: sc('border.strong'), strokeWidth: 3 }}
      />
      <rect x="56" y="44" width="48" height="7" rx="3.5" style={{ fill: c('gold.300') }} />
      <rect x="56" y="58" width="34" height="7" rx="3.5" style={{ fill: sc('border.default') }} />
      <path
        d="M26 66h108v58a10 10 0 0 1-10 10H36a10 10 0 0 1-10-10z"
        style={{ fill: c('berry.400') }}
      />
      <path d="M26 66l54 38 54-38" style={{ fill: c('berry.500') }} />
      <path
        d="M80 94c-6-8-18-4-14 4 2 4 14 12 14 12s12-8 14-12c4-8-8-12-14-4z"
        style={{ fill: c('gold.400') }}
      />
    </IllustrationFrame>
  );
}
